const validGuidCustomValidation = (input) => {
  const isValid = /^[a-f\d]{8}-[a-f\d]{4}-4[a-f\d]{3}-[89aAbB][a-f\d]{3}-[a-f\d]{12}$/.test(input) || !input //if empty the isRequired will kick in
  const validationMessage = "The Bureau Company Key should be a valid guid"
  return  [isValid, validationMessage]
}

export default [
  {
    key: "name",
    rules: {
      isRequired: true,
    }
  },
  {
    key: "description",
    rules: {
      isRequired: true,
    }
  },
  {
    key: "applicationCategoryId",
    rules: {
      isRequired: true,
    }
  },
  {
    key: "isSingleTenant",
    rules: {
      isRequired: false,
    }
  },
  {
    key: "agencyCompanyKey",
    rules: {
      isRequired: false,
      customValidation: {
        func: validGuidCustomValidation
      }
    }
  }
]
